module.exports = __webpack_public_path__ + "static/media/menu-icon.a560bdcb.svg";